import { AgentRecordingMessageType, AnnotationMessageType, ReturnCode } from "app/modules/remote-control-ng/definitions";
import { AdminCommandTypes, AdminMessage, AgentDumpLogMessage, AgentRecordingMessage, AnnotationMessage } from "../messages/pocket-com";
import { RequestReplyService } from "../../remote-control-ng/services/requestReplyService";
import { BaseCommand } from "./baseCommand";
import { RcContext } from "../../remote-control-ng/context/rcContext";
import { NgRemoteControlConnection } from "app/modules/remote-control/services/remote-control.connection";
import { Injector } from "@angular/core";

export class AgentDumpLogCommand extends BaseCommand<AgentDumpLogMessage> {
    constructor(private injector: Injector) {
        super(AgentDumpLogMessage);
    }

    protected doProcess(message: AgentDumpLogMessage): void {
        // this request is invoked from the RcLogsService.getDeviceLogsCategories
        this.injector.get(RequestReplyService).processReply(message);
    }
}

export class AgentRecordingCommand extends BaseCommand<AgentRecordingMessage> {
    constructor(private injector: Injector) {
        super(AgentRecordingMessage);
    }

    protected doProcess(message: AgentRecordingMessage): void {
        if (message.isRequest) {
            message.response.errorCode = message.errorCode || 0;
            if (!this.injector.get(RequestReplyService).processReply(message)) {
                // if no callback expected fire an event
                if (message.messageType === AgentRecordingMessageType.ARM_STOP_RECORDING) {
                    const evt = Object.assign(new Event('rcAgentRecordingStoppedByUser', { 'bubbles': true, 'cancelable': true }), {
                        deviceId: RcContext.instance.deviceId,
                        errorReason: message.response.errorCode
                    });
                    document.dispatchEvent(evt);
                } else {
                    console.error(`Missing agent recording handler for agent recording message type: ${message.messageType} request id ${message.reqId}`);
                }
            }
        } else {
            // we do not have callback which means request was initiated form device side
            // so we emit event corresponding to the type of annotation message instead
            if (message.messageType === AgentRecordingMessageType.ARM_STOP_RECORDING) {
                const evt = Object.assign(new Event('rcAgentRecordingStopped', { 'bubbles': true, 'cancelable': true }), {
                    deviceId: RcContext.instance.deviceId,
                    videoPath: message.response.videoPath,
                    errorReason: message.response.errorCode
                });
                document.dispatchEvent(evt);
            } else if (AgentRecordingMessageType[message.messageType] === undefined) {
                console.error(`Received unexpected video recording event ${message.messageType}`);
            }
        }

    }
}

export class AnnotationCommand extends BaseCommand<AnnotationMessage> {
    constructor(private injector: Injector) {
        super(AnnotationMessage);
    }

    protected doProcess(message: AnnotationMessage): void {
        if (message.isRequest) {
            message.response.deviceId = RcContext.instance.deviceId;
            if (!this.injector.get(RequestReplyService).processReply(message)) {
                console.error(`Missing annotation handler for annotation message type: ${message.messageType} request id ${message.reqId}`);
            }
        } else {
            // we do not have callback which means request was initiated form device side
            // so we emit event corresponding to the type of annotation message instead
            if (message.messageType === AnnotationMessageType.AM_TOGGLE_ANNOTATION) {
                let evt = Object.assign(new Event('rcAnnotationMessage', { 'bubbles': true, 'cancelable': true }), {
                    deviceId: RcContext.instance.deviceId,
                    toggleState: message.response.toggleState
                });
                document.dispatchEvent(evt);
            } else if (AnnotationMessageType[message.messageType] === undefined) {
                console.error(`Received unexpected annotation message ${message.messageType}`);
            }
        }
    }
}

// TODO RC unit tests - Add unit test once support multi-view
/* istanbul ignore next */
export class MultiViewCommand extends BaseCommand<AdminMessage> {
    constructor() {
        super(AdminMessage);
    }

    /** *provisional code* joining sessions is not yet supported in 2024/2025 */
    protected override doProcess(message: AdminMessage): void {
        switch (message.commandType) {
            case AdminCommandTypes.joinSessionRequest:    // join session request
                if (message.state.organizer === message.state.myId) {
                    // get userId userName from message and refresh session
                    // var event = new CustomEvent('JoinSessionRequest', { user: userId, name: userName });
                    // document.dispatchEvent(event);
                }
                // streaming RC code:
                // FIXME - when MultiView is supported by front-end, rewrite this code to handle joining properly.
                // DS 15.6.0 has MultiView enabled, hence will try to join by send PC_ADMIN message to organizer when forceOverride is false
                // for now, just reply an approve message and let 2nd console determine if disconnect.
                const reply = new AdminMessage({
                    commandType: AdminCommandTypes.addViewer,
                    userId: message.userId,
                    approved: true
                });
                console.log("PC_ADMIN: Join session request from " + message.userId);
                (<NgRemoteControlConnection>RcContext.instance.deviceContext.remoteControlConnection).send(reply)
                break;

            case AdminCommandTypes.event:    // session event
                // get evtType, userId, userName, message from message reply
                //  refresh session
                // var event = new CustomEvent('SessionEvent', { type: evtType.toString(10), user: userId, name: userName, message: message });
                // document.dispatchEvent(event);
                break;

            case AdminCommandTypes.multiviewInfo:    // session info
                const userId = message.state.myId;
                const permission = message.state.permissions; // convert from BigInt, or not?
                const organizer= message.state.organizer;
                const controller = message.state.controller;

                // if (message.response.permissions != 0) {
                //     RcContext.instance.security.initialize(message.response.permissions);
                // }
                // Streaming RC code
                // FIXME - when MultiView is supported by front-end, rewrite this code
                // Disconnect if there's an existing session and DS tries to join
                if (userId !== organizer && !RcContext.instance.forceOverride) {
                    RcContext.instance.session.setLastError(ReturnCode.PCR_ALREADY_CONNECTED);
                    RcContext.instance.deviceContext.remoteControlConnection.disconnect();
                }
                break;

            case AdminCommandTypes.viewerList:    // viewer list
                // refresh UI
                break;

            case AdminCommandTypes.organizerChanged:
                // refresh UI
                break;

            case AdminCommandTypes.controllerChanged:
                // refresh UI
                break;
        }
    };

}

